// computeEditCategoryHasUnsavedChanges.ts
import { EditCategoryState } from './mapCategoryToEditState';

export const computeEditCategoryHasUnsavedChanges = (
  current: EditCategoryState,
  baseline: EditCategoryState,
): boolean => JSON.stringify(current) !== JSON.stringify(baseline);
